"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateWithoutTime = exports.Week = void 0;
// https://javascript.plainenglish.io/publishing-a-typescript-npm-package-with-github-actions-7f6486e7da95
var Week_1 = require("./Week");
Object.defineProperty(exports, "Week", { enumerable: true, get: function () { return Week_1.Week; } });
var DateWithoutTime_1 = require("./DateWithoutTime");
Object.defineProperty(exports, "DateWithoutTime", { enumerable: true, get: function () { return DateWithoutTime_1.DateWithoutTime; } });
